import React, { Suspense, useContext } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import KonfhubLoad from "../components/KonfhubLoad";
import AllRoutes from "./Routes";
import AuthContext from "../contexts/AuthContext";
import EventDashboardPage from "../revampPages/ManageEvents/EventDashboardPage";

export default function EventDashboardRoutes(props) {
    const Context = useContext(AuthContext);

    return (
        <Suspense fallback={<KonfhubLoad />}>
            <EventDashboardPage>
                <Switch>
                    {AllRoutes.map((route, index) => {
                        switch (route.authentication) {
                            case "unauthenticated":
                                return (
                                    <Redirect exact from={route.path} to="/" key={index} />
                                );

                            case "authenticated":
                            case "both":
                            default:
                                if (route.Eventdashboard) {
                                    return (
                                        <Route
                                            key={index}
                                            exact
                                            path={route.path}
                                            render={(pageProps) => (
                                                <route.component {...props} {...pageProps} />
                                            )}
                                        />
                                    );
                                }
                                return null;
                        }
                    })}
                </Switch>
            </EventDashboardPage>
        </Suspense>
    );
}
